import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/organization/address', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/organization/address', params, payload, config)
  },
}
